export enum RemitoEstado {
  Borrador,
  Enviado,
  Recepcionado,
}

export const RemitoEstadoLabels: { [key in RemitoEstado]: string } = {
  [RemitoEstado.Borrador]: 'Borrador',
  [RemitoEstado.Enviado]: 'Enviado',
  [RemitoEstado.Recepcionado]: 'Recepcionado',
};

export const getRemitoEstado = () => {
  return Object.values(RemitoEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: RemitoEstadoLabels[id as RemitoEstado],
    }));
};

export const colorMapping: { [key in RemitoEstado]: string } = {
  [RemitoEstado.Borrador]: '#70BDFF',
  [RemitoEstado.Enviado]: 'orange',
  [RemitoEstado.Recepcionado]: '#22c55e',
};
